import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { art } from "../state/params.svelte";

var root = $.from_html(`<div role="status">press <kbd class="svelte-1jb8ohpe2bth6">space</kbd> to shuffle</div>`);

export default function Hint($$anchor, $$props) {
	$.push($$props, true);

	// Landing hint: tells first-time visitors the one gesture that matters.
	// Dismissed by the shuffle itself (not raw key events — embedded browsers
	// fire synthetic keydowns after navigation) or by the timeout.
	let expired = $.state(false);

	const gone = $.derived(() => $.get(expired) || art.shuffled);

	$.user_effect(() => {
		const timer = setTimeout(() => $.set(expired, true), 8000);

		return () => clearTimeout(timer);
	});

	var div = root();
	let classes;

	$.template_effect(() => classes = $.set_class(div, 1, 'hint svelte-1jb8ohpe2bth6', null, classes, { gone: $.get(gone) }));
	$.append($$anchor, div);
	$.pop();
}
import "bun-svelte:Hint.svelte-26nk797ph8erk-style.css";